import { Component, ElementRef, OnDestroy, ChangeDetectionStrategy, inject } from '@angular/core';
import {ModalService} from '../../../Services/modal.service';


@Component({
    selector: 'app-modal-information-message',
    templateUrl: './ModalInformationMessage.html',
    styleUrl: "./ModalInformationMessage.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class ModalInformationMessage implements OnDestroy {
  private variables = inject<any>('variables' as any);
  protected modalService = inject(ModalService);
  private ref = inject(ElementRef);


  protected message: string = "";
  animatedWidthPercentage: number = 100;
  private animationActive: boolean = true;

  ngOnInit(): void {
    this.message = this.variables.message || '';

    if(localStorage.getItem("last-message-shown") === this.message) {
      this.modalService.close();
      return;
    }

    localStorage.setItem("last-message-shown", this.message);

    this.ref.nativeElement.addEventListener('click', (ev: any) => {
      if (ev.target === this.ref.nativeElement) {
        this.close();
      }
    });

    this.animatedWidthPercentage = 0; // Initialisation à 0%
    const animationDuration = 7500; // Durée totale en millisecondes
    const startTime = performance.now();
    const animate = (currentTime: number) => {
      if (!this.animationActive) {
        return;
      }

      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / animationDuration, 1); // Progression de 0 à 1

      this.animatedWidthPercentage = progress * 100; // Calcul de la largeur en pourcentage

      if (progress < 1) {
        requestAnimationFrame(animate); // Continuer l'animation
      } else {
        this.modalService.close();
      }
    };

    requestAnimationFrame(animate);
  }

  ngOnDestroy(): void {
    this.animationActive = false;
  }

  close(ev?: MouseEvent) {
    this.animationActive = false;
    this.modalService.close();
  }
}
